import { AuthenticationContext } from 'contexts/Auth';
import { useContextSelector } from 'use-context-selector';

const useAuth = () => {
	const signIn = useContextSelector(
		AuthenticationContext,
		({ handleSignIn }) => {
			return handleSignIn;
		},
	);
	const signOut = useContextSelector(
		AuthenticationContext,
		({ handleSignOut }) => handleSignOut,
	);
	const newPassword = useContextSelector(
		AuthenticationContext,
		({ handleNewPassword }) => handleNewPassword,
	);
	const passwordRecover = useContextSelector(
		AuthenticationContext,
		({ handlePasswordRecover }) => handlePasswordRecover,
	);
	const isAuthenticated = useContextSelector(
		AuthenticationContext,
		({ isAuthenticated }) => isAuthenticated,
	);
	const isLoading = useContextSelector(
		AuthenticationContext,
		({ isLoading }) => isLoading,
	);
	const errorInfo = useContextSelector(
		AuthenticationContext,
		({ errorInfo }) => errorInfo,
	);

	return {
		signIn,
		signOut,
		newPassword,
		passwordRecover,
		isAuthenticated,
		isLoading,
		errorInfo,
	};
};

export { useAuth };
